module.exports = "<label class=\"select\">\n  <select [name]=\"name\" (change)=\"selectItem($event)\" [(ngModel)]=\"value\">\n    <ng-content></ng-content>\n    <option [value]=\"option.value\" *ngFor=\"let option of options\">{{option.title}}</option>\n  </select>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/select/select.component.html
// module id = BZcr
// module chunks = 6